import { AppInsightsContext } from '@shared/lib/AppInsightsContext';
import { appInsights } from '@shared/lib/applicationInsights';
import React, { ReactNode } from 'react';

interface ApplicationInsightsProviderProps {
  children: ReactNode;
}

export const ApplicationInsightsProvider: React.FC<ApplicationInsightsProviderProps> = ({ children }) => {
  return <AppInsightsContext.Provider value={appInsights}>{children}</AppInsightsContext.Provider>;
};
